// extracted by mini-css-extract-plugin
export var option = "_5c-0";
export var optionCard = "_5c-f";
export var optionContent = "_5c-g";
export var optionIcon = "_5c-i";
export var optionIconBox = "_5c-h";
export var optionLabel = "_5c-j";
export var optionPill = "_5c-m";
export var optionPillBadge = "_5c-p";
export var optionPillIcon = "_5c-n";
export var optionPillLabel = "_5c-o";
export var optionRadio = "_5c-k";
export var optionRadioInner = "_5c-l";
export var optionReveal = "_5c-2";
export var optionRevealDelay0 = "_5c-3";
export var optionRevealDelay1 = "_5c-4";
export var optionRevealDelay10 = "_5c-d";
export var optionRevealDelay11 = "_5c-e";
export var optionRevealDelay2 = "_5c-5";
export var optionRevealDelay3 = "_5c-6";
export var optionRevealDelay4 = "_5c-7";
export var optionRevealDelay5 = "_5c-8";
export var optionRevealDelay6 = "_5c-9";
export var optionRevealDelay7 = "_5c-a";
export var optionRevealDelay8 = "_5c-b";
export var optionRevealDelay9 = "_5c-c";
export var optionSelected = "_5c-1";